import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import StaffDashboard from './pages/StaffDashboard';
import GateDashboard from './pages/GateDashboard';
import VisitorPage from './pages/VisitorPage';
import PermissionGate from './components/PermissionGate';
import AppUpdateChecker from './components/AppUpdateChecker';
import AppVersionGuard from './components/AppVersionGuard';
import NativeShell from './components/NativeShell';

function App() {
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  const PrivateRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <PermissionGate>
        <NativeShell />
        <AppUpdateChecker />
        <AppVersionGuard />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={<PrivateRoute><AdminDashboard /></PrivateRoute>}
          />
          <Route
            path="/staff"
            element={<PrivateRoute><StaffDashboard /></PrivateRoute>}
          />
          <Route
            path="/gate"
            element={<PrivateRoute><GateDashboard /></PrivateRoute>}
          />
          <Route path="/visitor" element={<VisitorPage />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </PermissionGate>
    </Router>
  );
}

export default App;
